import builder from '../builders/base';

export default {
  getServices: () => builder()
    .setMethod('GET')
    .setUrl('services')
    .build(),
};



// WEBPACK FOOTER //
// ./src/services/modules/service.js